module.exports = __webpack_public_path__ + "static/media/vulcano_1k.782a5c8c.webp";